import React from 'react';
import { Progress } from 'reactstrap';
import Firebase from 'firebase';
import RenderComponents from './renderComponents';

export default class uploadImages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            photos: "",
            up: "none",
            progress: 0
        }
        this.upload = this.upload.bind(this);
    }

    upload(file) {
        var metadata = {
            contentType: 'image/jpeg'
        };
        let arrayElement = [];
        let elements = this.props.elements;
        const contex = this;
        var storageRef = Firebase.storage().ref();
        var directory = localStorage.client_id + '/images/' + this.state.photo.name;
        var uploadTask = storageRef.child(localStorage.client_id + '/images/' + this.state.photo.name).put(this.state.photo, metadata);
        uploadTask.on(Firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                contex.setState({ progress: progress });
                switch (snapshot.state) {
                    case Firebase.storage.TaskState.PAUSED: // or 'paused'
                        break;
                    case Firebase.storage.TaskState.RUNNING: // or 'running'
                        break;
                }
            }, function (error) {
                switch (error.code) {
                    case 'storage/unauthorized':
                        break;
                    case 'storage/canceled':
                        break;
                    case 'storage/unknown':
                        break;
                }
            }, function () {
                var downloadURL = uploadTask.snapshot.downloadURL;
                Object.keys(elements).map(function (objectKey, index) {
                    var value = elements[objectKey];
                    if (value.id == contex.props.element.id) {
                        value.uri = downloadURL;
                        value.value = directory;
                    }
                    arrayElement.push(value);
                });
                contex.props.callBack(elements);
            });
    }

    render() {
        var reader = new FileReader();
        const contex = this;
        return (
            <div>
                <div className="form-group" style={{ width: "80%", marginLeft: "10%" }}>
                    {
                        this.state.photo ?
                            <div className="text-center">
                                <img id="imagen" src="" width="300" />
                                <br />
                                <br />
                                <Progress className="progress-xs" color="success" value={this.state.progress} id="progress" />
                            </div>
                            :
                            ""
                    }
                    <div className="input-group image-preview">
                        <input placeholder="" type="text" className="form-control image-preview-filesheetName"
                            value={this.state.photo ? this.state.photo.name : ""} disabled="disabled"
                        />
                        <span className="input-group-btn">
                            <button
                                type="button"
                                className="btn btn-default image-preview-clear"
                                style={{ display: "none" }}>
                                <span
                                    className="glyphicon glyphicon-remove">
                                </span>
                                Clear
                                </button>
                            <div  className="btn btn-primary image-preview-input" onClick={() => { var l = document.getElementById('inputFile'); l.click(); }} >
                                <span
                                    className="image-preview-input-title">
                                    Buscar
                                    </span>
                                <input
                                    style={{ display: "none" }}
                                    id="inputFile"
                                    type="file"
                                    accept=".png,.jpg"
                                    sheetName="input-file-preview"
                                    onChange={(e) => {
                                        this.setState({ photo: e.target.files[0], display: "" });
                                        reader.onload = function (e) {
                                            document.getElementById('imagen').src = e.target.result;
                                        }
                                        reader.readAsDataURL(e.target.files[0]);
                                    }}
                                />
                            </div>
                        </span>
                        <div style={{ display: this.state.display }} >
                            {
                                this.state.photo !== {} ?
                                    <a  onClick={() => { this.upload() }} className="btn btn-success">Subir foto</a>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/uploadImages.js